/* @flow */

export const appendQueryParameter = (uri: string, appendString: string) => {
  const prefix = uri.includes('?') ? '&' : '?';

  return `${uri}${prefix}${appendString}`;
};

export type BasicParamItem = { key: ?string, values: string[] };
export const convertToSearchString = (params: BasicParamItem[]) =>
  params.reduce(
    (result, item, index) =>
      `${result}${index === 0 ? '' : ';'}${item.key ? `${item.key}:` : ''}${item.values.join('|')}`,
    ''
  );
